import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Outlet } from 'react-router-dom';
import { toRelativeUrl } from '@okta/okta-auth-js';
import Loading from '../mir-styles/src/components/Loading/Loading';

export const RequiredAuth = () => {
    const { oktaAuth, authState } = useOktaAuth();

    useEffect(() => {
        if (!authState) {
            return;
        }

        if (!authState?.isAuthenticated) {
            const originalUri = toRelativeUrl(window.location.href, window.location.origin);
            oktaAuth.setOriginalUri(originalUri);
            oktaAuth.signInWithRedirect();
        }
    }, [authState, oktaAuth]);

    if (!authState || !authState?.isAuthenticated) {
        return (<Loading />);
    }

    return (<Outlet />);
}